import { Factory } from 'fishery';
import { Line } from '@trukt/types/Line';
import { commodityFactory } from './commodityFactory';
import { userFactory } from './userFactory';

export const lineFactory = Factory.define<Line>(({ sequence }) => ({
  guid: sequence.toString(),
  notes: 'export to netsuite',
  amount: '470.53',
  itemId: '1',
  dateCreated: '2022-08-26T22:28:00.796Z',
  isPaid: false,
  dateCharged: '2022-08-26T22:28:00.796Z',
  transactionNumber: '6202dc92-25f7-43aa-9928-df8455db06fd',
  systemDefined: false,
  systemUsage: '',
  createdBy: userFactory.build(),
  commodity: commodityFactory.build(),
  name: 'diagnostics',
  isAccessorial: false,
  expense: '0.00',
  revenue: '470.53',
}));
